'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = 'M40.5 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm416 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM475.8 36.7c6.2 6.2 6.2 16.4 0 22.6l-19 19C445.5 89.6 430.1 96 414.1 96l-11 0c-14 0-23.8 13.7-19.4 26.9 11.3 34-14 69.1-49.8 69.1l-11 0c-7.5 0-14.8 3-20.1 8.3l-19 19c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l19-19c11.3-11.3 26.7-17.7 42.7-17.7l11 0c14 0 23.8-13.7 19.4-26.9-11.3-34 14-69.1 49.8-69.1l11 0c7.5 0 14.8-3 20.1-8.3l19-19c6.2-6.2 16.4-6.2 22.6 0zM240.5 32l0 24.2c0 29.7-11.8 58.2-32.8 79.2l-19.9 19.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l19.9-19.9c15-15 23.4-35.4 23.4-56.6l0-24.2c0-8.8 7.2-16 16-16s16 7.2 16 16zM89.3 212.3c7.2-22.9 36.2-30 53.1-13L313.2 370.1c17 17 9.9 45.9-13 53.1L50.7 502c-24.7 7.8-48-15.4-40.2-40.2L89.3 212.3zM290.5 392.7l-170.7-170.7-16 50.7 4 4 128 128 4 4 50.7-16zm-85.1 26.9l-112.5-112.5-19.9 62.9 2.7 2.7 64 64 2.7 2.7 62.9-19.9zM41 471.5l67.1-21.2-45.9-45.9-21.2 67.1zM496.5 288c0 8.8-7.2 16-16 16l-24.2 0c-21.2 0-41.6 8.4-56.6 23.4l-19.9 19.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l19.9-19.9c21-21 49.5-32.8 79.2-32.8l24.2 0c8.8 0 16 7.2 16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;